const AZARJS_V2_MIN_VERSION = 2452;

export const isAzarJsV2 = () =>
  typeof window === 'undefined'
    ? false
    : (Number(window.AzarJs?.getApiVersion?.()) || 0) >= AZARJS_V2_MIN_VERSION;
